var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import ReactPlotlyDefault from "react-plotly.js";
// Under webpack's strict-ESM rule for lift-ui/dist (see webpack.config.js
// `type: 'javascript/esm'`), the CJS default import resolves to the whole
// module.exports object (`{ default: PlotComponent, __esModule: true }`),
// not the inner default. Unwrap one more level when that happens.
var Plot = (_a = ReactPlotlyDefault === null || ReactPlotlyDefault === void 0 ? void 0 : ReactPlotlyDefault.default) !== null && _a !== void 0 ? _a : ReactPlotlyDefault;
export function PlotlyChart(_a) {
    var _b;
    var data = _a.data, layout = _a.layout, config = _a.config, _c = _a.height, height = _c === void 0 ? 350 : _c;
    /*
     * Merge caller-provided layout with our sensible defaults. Autosize ensures
     * charts fill the flex / grid container they live in. Users can opt-out by
     * passing explicit width / height values.
     */
    var mergedLayout = __assign({ autosize: true }, layout);
    var inlineStyle = {
        width: "100%",
        height: (_b = mergedLayout.height) !== null && _b !== void 0 ? _b : height,
    };
    return (_jsx("div", { className: "w-full", children: _jsx(Plot, { data: data, layout: mergedLayout, config: config, style: inlineStyle, useResizeHandler: true }) }));
}
